export class Sinonimo {
	idSinonimo: number;
	idRecurso: number;
	sinonimo: string;

	constructor (sinonimo: string) {
		this.sinonimo = sinonimo;
		return this;
	}
}